import NoConnection from "@/modules/app/components/NoConnection";

export default function StatusBar() {
  return <NoConnection style={{ mb: "24" }} />;
}
